import * as AllIcons from './components/index'

import { SvgIconProps } from './Icon.types'
import styles from './Icon.module.scss'

export type IconName = keyof typeof AllIcons
// Props for the dynamic Icon component (with required name)

export interface IconProps extends SvgIconProps {
  iconName: IconName
}

const Icon = (props: IconProps) => {
  const { iconName, ...restProps } = props
  if (!iconName) {
    console.info('Icon component requires an iconName prop')
    return null
  }

  if (iconName && AllIcons[iconName as keyof typeof AllIcons]) {
    const Component = AllIcons[
      iconName as keyof typeof AllIcons
    ] as React.FC<SvgIconProps>
    return (
      <Component
        className={styles.icon}
        {...restProps}
      />
    )
  }
}

Icon.displayName = 'Icon'

// Re-export all individual icons
export * as IconComponents from './components/index'
export default Icon
